import { ProductFamiliesThemeSizeConfig } from './types';

const small: ProductFamiliesThemeSizeConfig = {
  productFamilies: {},
};

export default small;
